import { ApiBackClient } from '../../services/apiADA';
import { saveInSessionStorage, getFromSessionStorage, getFromLocalStorage } from '../../contexts/LocalStorage';

export function postNotification(objNotification) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/notification", objNotification,
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: getFromSessionStorage("userlogin"),
                    Authorization: `Bearer ${getFromSessionStorage("logid")}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                if(res.headers.logid !== undefined)
                    saveInSessionStorage("logid", res.headers.logid);
                resolve("Success");
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function putNotification(idNotification, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.put("/notification", {'visualizado': true},
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`,
                    notification: idNotification
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                if(res.headers.logid !== undefined)
                    saveInSessionStorage("logid", res.headers.logid);
                resolve(res.data);
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function getNotification(idNotification, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.get("/notification",
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`,
                    notification: idNotification
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                if(res.headers.logid !== undefined)
                    saveInSessionStorage("logid", res.headers.logid);
                resolve(res.data);
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function deleteNotification(idNotification, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.delete("/notification",
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`,
                    notification: idNotification
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                if(res.headers.logid !== undefined)
                    saveInSessionStorage("logid", res.headers.logid);
                resolve("Success");
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

function consoleLogErros(error) {
    console.log("error validação");
    console.log(error);
    if (error.response) {
        // Requisição feita e o servidor retornou um erro
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
    } else if (error.request) {
        // A requisição foi feita, mas nenhuma resposta foi recebida
        console.error(error.request);
    } else {
        // Alguma coisa aconteceu nas configurações da requisição que gerou um erro
        console.error('Error', error.message);
    }
}